var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBliggitEyedown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 242 265",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ArtBoard2",
    transform: "matrix(0.537778,0,0,1.01344,0,-4.82095)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 338.275,
    width: 450,
    height: 261.486,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7983,0,0,0.954262,225.792,592.902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-258.781C-64.033,-258.781 -115.941,-206.872 -115.941,-142.84C-115.941,-89.287 -79.623,-44.238 -30.279,-30.919L-9.964,-6.268C-4.799,0 4.802,0 9.967,-6.268L30.283,-30.92C79.625,-44.24 115.941,-89.288 115.941,-142.84C115.941,-206.872 64.032,-258.781 0,-258.781M0,-75.893C-36.974,-75.893 -66.947,-105.866 -66.947,-142.84C-66.947,-179.814 -36.974,-209.786 0,-209.786C36.974,-209.786 66.947,-179.814 66.947,-142.84C66.947,-105.866 36.974,-75.893 0,-75.893",
    style: {
      fill: "rgb(20,55,62)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.7983,0,0,0.954262,269.065,513.414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-59.446C16.416,-59.446 29.723,-46.139 29.723,-29.723C29.723,-13.308 16.416,0 0,0C-16.416,0 -29.723,-13.308 -29.723,-29.723C-29.723,-46.139 -16.416,-59.446 0,-59.446",
    style: {
      fill: "rgb(20,55,62)",
      fillRule: "nonzero"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBliggitEyedown);
export default __webpack_public_path__ + "static/media/Bliggit_eyedown.64722d15b9b116f1c407cbdaa00a0128.svg";
export { ForwardRef as ReactComponent };